module.exports = __webpack_public_path__ + "static/img/041003.20b6afd5.png";